import { Link } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import TextField from 'shared/components/text-field/TextField';
import Button from 'shared/components/button/Button';
import PasswordField from 'shared/components/password-field/PasswordField';
import VerificationEmailIsSent from 'features/auth/components/register/VerificationEmailIsSent';
import { loginSchema } from 'utils/validators/login';
import sideBg from 'assets/img/content/AdminScreen.jpg';

import { AuthContext } from 'features/auth/context/Auth';
import './Login.scss';
import { signin, clearAuthState, resendVerificationEmail } from '../../ducks/authActions';

const Login = props => {
  let {
    authMsg,
    passwordErrorMsg,
    emailErrorMsg,
    firstLogIn,
    unverifiedEmail,
    loading
  } = props;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    props.clearAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { from } = props.location.state || (
      firstLogIn ? { from: { pathname: '/onboarding' }} : { from: { pathname: '/' } }
    );
  const { currentUser } = useContext(AuthContext) || {};
  if (!loading && currentUser && currentUser.emailVerified) {
    return <Redirect to={from} />;
  }

  const resendVerification = () => {
    props.resendVerificationEmail(email, password);
  }

  if (unverifiedEmail) {
    return (
      <VerificationEmailIsSent
        resendVerification={resendVerification}
        loading={loading}
        unverifiedEmail={unverifiedEmail}
      />
    );
  }

  return (
    <Formik
      initialValues={{ email: '', password: '' }}
      onSubmit={async values => {
        setEmail(values.email);
        setPassword(values.password);
        props.clearAuthState();
        return props.signin(values.email, values.password);
      }}
      validationSchema={loginSchema}
      validate={() => {
        let errors = {};
        if (authMsg) errors.password = 'Incorrect Password';
        authMsg = false;
        return errors;
      }}
    >
      {({ isSubmitting }) => {
        return (
          <div className="onboarding onboarding-login">
            <div className="login">
              <div className="img-side">
                <img src={sideBg} alt="hybrid-trainer" />
              </div>
              <div className="form-side">
                <div className="shape shape-left"></div>
                <div className="shape shape-right"></div>
                <div className="form-content">
                  <h3>
                    Hybrid <br /> Training
                  </h3>
                  <Form>
                    {}
                    <TextField
                      type="text"
                      name="email"
                      label="Email"
                      placeholder="trainer@hybridmmafit.com"
                      error={emailErrorMsg ? emailErrorMsg : false}
                    />
                    <PasswordField error={passwordErrorMsg} />
                    <div className="form-action">
                      <Button
                        id="submit-btn"
                        type="submit"
                        btnBlock="block"
                        color="primary"
                        label="Log In"
                        disabled={isSubmitting}
                      />
                    </div>
                  </Form>
                  <div className="forgot-pass">
                    <Link to="/password/forget">Forgot Password?</Link>
                  </div>
                  <div className="form-text">
                    <p>
                      Are you a trainer?{' '}
                      <Link to="register">Create Account</Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }}
    </Formik>
  );
};

Login.propTypes = {
  fields: PropTypes.shape({
    email: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired
  })
};

function mapStateToProps(state) {
  return {
    authMsg: state.authReducer.authMsg,
    emailErrorMsg: state.authReducer.emailMsg,
    passwordErrorMsg: state.authReducer.passwordMsg,
    firstLogIn: state.authReducer.firstLogIn,
    unverifiedEmail: state.authReducer.unverifiedEmail,
    loading: state.authReducer.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clearAuthState: () => dispatch(clearAuthState()),
    signin: (email, password, callback) =>
      dispatch(signin(email, password, callback)),
    resendVerificationEmail: (email, password) =>
      dispatch(resendVerificationEmail(email, password))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
